import { useEffect, useState } from 'react';
import { useTheme } from '@fluentui/react';

import logo from 'assets/images/logo.svg';
import footerLogo from 'assets/images/footer-logo.svg';
import footerWhiteLogo from 'assets/images/menu-logo.svg';

const brandCache = {
  '': { mainLogo: logo, smallLogo: footerLogo, smallLightLogo: footerWhiteLogo },
};

export function loadDefaultTheme() {
  return {
    semanticColors: {
      buttonTextDisabled: '#d0d0d0',
    },
    palette: {
      themePrimary: '#507f70',
      themeLighterAlt: '#f6faf9',
      themeLighter: '#ddebe6',
      themeLight: '#49C5B1',
      themeTertiary: '#8bb3a6',
      themeSecondary: '#608f80',
      themeDarkAlt: '#487365',
      themeDark: '#3d6156',
      themeDarker: '#2d473f',
      neutralLighterAlt: '#faf9f8',
      neutralLighter: '#f3f2f1',
      neutralLight: '#edebe9',
      neutralQuaternaryAlt: '#e1dfdd',
      neutralQuaternary: '#d0d0d0',
      neutralTertiaryAlt: '#c8c6c4',
      neutralTertiary: '#595959',
      neutralSecondary: '#373737',
      neutralPrimaryAlt: '#2f2f2f',
      neutralPrimary: '#000000',
      neutralDark: '#151515',
      black: '#0b0b0b',
      white: '#ffffff',
    },
    loadBrand: async () => brandCache[''],
    Navigation: {
      palette: {
        themePrimary: '#323130',
        neutralPrimary: '#323130',
        white: '#49C5B1',
      },
    },
  };
}


export function loadBrandedTheme(brand) {
  return {
    semanticColors: {
      buttonTextDisabled: '#d0d0d0',
    },
    palette: {
      themePrimary: '#4b5e6b',
      themeLighterAlt: '#f6f8f9',
      themeLighter: '#dce3e7',
      themeLight: '#4b5e6b',
      themeTertiary: '#889aa6',
      themeSecondary: '#5c707d',
      themeDarkAlt: '#435560',
      themeDark: '#394851',
      themeDarker: '#2a353c',
      neutralLighterAlt: '#faf9f8',
      neutralLighter: '#f3f2f1',
      neutralLight: '#edebe9',
      neutralQuaternaryAlt: '#e1dfdd',
      neutralQuaternary: '#d0d0d0',
      neutralTertiaryAlt: '#c8c6c4',
      neutralTertiary: '#bab8b7',
      neutralSecondary: '#a3a2a0',
      neutralPrimaryAlt: '#8d8b8a',
      neutralPrimary: '#323130',
      neutralDark: '#605e5d',
      black: '#494847',
      white: '#ffffff',
    },
    loadBrand: async () => {
      if (!brandCache[brand]) {
        brandCache[brand] = await import(/* webpackChunkName: "navatar" */ 'assets/images/navatar');
      }
      return brandCache[brand];
    },
    Navigation: {
      palette: {
        themePrimary: '#ffffff',
        neutralPrimary: '#ffffff',
        white: '#4b5e6b',
      },
    },
  };
}

export function useBrandedLogos() {
  const theme = useTheme();
  const [result, setResult] = useState({});

  useEffect(() => {
    (async function load() {
      setResult(await theme.loadBrand());
    })();
  }, [theme]);

  return result;
}